var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    display: "inline-block",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.966 10.667a.495.495 0 10.7-.7L8.499 7.8V5.167a.5.5 0 10-1 0v2.722c0 .2.08.39.22.53l2.247 2.248zm-1.967 3.666a6.176 6.176 0 01-2.474-.5 6.389 6.389 0 01-2.009-1.35 6.388 6.388 0 01-1.35-2.008A6.175 6.175 0 011.666 8c0-.878.167-1.703.5-2.475a6.389 6.389 0 011.35-2.008 6.387 6.387 0 012.009-1.35 6.175 6.175 0 012.474-.5 6.18 6.18 0 012.476.5 6.389 6.389 0 012.008 1.35 6.39 6.39 0 011.35 2.008c.333.772.5 1.597.5 2.475 0 .878-.167 1.703-.5 2.475a6.39 6.39 0 01-1.35 2.008 6.391 6.391 0 01-2.008 1.35 6.18 6.18 0 01-2.476.5zm0-1c1.478 0 2.737-.519 3.776-1.558 1.038-1.039 1.558-2.297 1.558-3.775 0-1.478-.52-2.736-1.558-3.775-1.04-1.039-2.298-1.558-3.776-1.558-1.477 0-2.736.519-3.774 1.558C3.185 5.264 2.666 6.522 2.666 8c0 1.478.52 2.736 1.559 3.775 1.038 1.039 2.297 1.558 3.774 1.558z",
    fill: "#2C353E"
  })));
}
export default SvgTime;